var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPctStep05({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 110,
    viewBox: "0 0 150 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_1430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1899 72.14V29.11H97.2399L97.4299 31.96H49.0399V72.14H46.1899Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.81 72.5V21.06H38.1401V72.5H34.0801V20.54C34.0801 19.59 34.4501 18.7 35.1201 18.04C35.7901 17.37 36.6801 17 37.6201 17H113.32C114.27 17 115.15 17.37 115.82 18.04C116.49 18.71 116.86 19.6 116.86 20.54V72.5H112.8H112.81Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.87 93.7201C30.03 93.7201 28.31 93.0101 27.01 91.7101C25.71 90.4101 25 88.6901 25 86.8501V77.5601H125.76V86.8501C125.76 88.6901 125.05 90.4101 123.75 91.7101C122.45 93.0101 120.73 93.7201 118.89 93.7201H31.87ZM28.93 86.8501C28.93 87.6001 29.22 88.3101 29.76 88.8401C30.3 89.3701 31 89.6701 31.75 89.6701H119.07C119.81 89.6701 120.54 89.3701 121.06 88.8401C121.59 88.3101 121.89 87.6001 121.89 86.8501V81.1901H90.07L89.81 80.8001C89.51 81.5201 89.01 82.1201 88.36 82.5501C87.71 82.9801 86.96 83.2101 86.18 83.2201H64.6C63.83 83.2201 63.08 82.9901 62.43 82.5501C61.78 82.1201 61.28 81.5101 60.98 80.8001L60.72 81.1901H28.93V86.8501Z",
    fill: "#82BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6799 42.41H62.8799L64.8299 53.75H88.1999L90.6799 42.41Z",
    fill: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 59.77H66.34C65.57 59.77 64.91 59.22 64.77 58.47L61.29 39.85H56.24V36.66H62.61C63.38 36.66 64.04 37.21 64.18 37.96L67.66 56.58H89.53L89 59.77Z",
    fill: "#50A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3799 54.99H65.7999V51.8H86.9799L88.1399 43.3H63.6699V40.11H89.9599C90.4199 40.11 90.8599 40.31 91.1599 40.66C91.4599 41.01 91.5999 41.47 91.5399 41.92L89.9499 53.61C89.8399 54.4 89.1699 54.99 88.3699 54.99H88.3799Z",
    fill: "#50A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3801 68.16C71.0756 68.16 72.4501 66.7855 72.4501 65.09C72.4501 63.3945 71.0756 62.02 69.3801 62.02C67.6845 62.02 66.3101 63.3945 66.3101 65.09C66.3101 66.7855 67.6845 68.16 69.3801 68.16Z",
    fill: "#50A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.77 68.16C85.4655 68.16 86.84 66.7855 86.84 65.09C86.84 63.3945 85.4655 62.02 83.77 62.02C82.0744 62.02 80.7 63.3945 80.7 65.09C80.7 66.7855 82.0744 68.16 83.77 68.16Z",
    fill: "#50A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.91 46.49H65.54V48.08H88.91V46.49Z",
    fill: "#50A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0299 42.24H72.4399V52.86H74.0299V42.24Z",
    fill: "#50A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4699 42.24H79.8799V52.86H81.4699V42.24Z",
    fill: "#50A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.7 37.87H102.13V68.7H104.7V37.87Z",
    fill: "#82BCFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_1430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100.76,
    height: 76.72,
    fill: "white",
    transform: "translate(25 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPctStep05);
export default __webpack_public_path__ + "static/media/pct_step05.d7462ecebd7b65397936f9d5a63a8391.svg";
export { ForwardRef as ReactComponent };